import api from "./api";

// Acoustic bulletins (existing)
export const getReports = async (country: string) => {
  const response = await api.get(`/report/${country}`);
  return response.data;
};

export const downloadReport = async (country: string, report: string) => {
  const response = await api.get(`/report/${country}/${report}`);
  return response.data;
};

// Ocean bulletins (Copernicus Marine)
export const getOceanReports = async (country: string, section?: string) => {
  const params = section ? `?section=${section}` : "";
  const response = await api.get(`/report/ocean/${country}${params}`);
  return response.data;
};

export const generateOceanReport = async (
  country: string,
  section?: string
) => {
  let url = `/report/ocean/generate?country=${country}`;
  if (section) url += `&section=${section}`;
  const response = await api.post(url);
  return response.data;
};

export const downloadOceanReport = async (
  country: string,
  filename: string
) => {
  const response = await api.get(`/report/ocean/${country}/${filename}`, {
    responseType: "blob",
  });
  return response.data;
};

// ── Email dispatch ──────────────────────────────────────────────────────────

/** Re-send a bulletin to all subscribers (admin only) */
export const dispatchBulletinManual = async (
  country: string,
  filename: string,
  section?: string,
  type: string = "ocean"
) => {
  const response = await api.post("/emails/dispatch-bulletin/manual", {
    country,
    filename,
    type,
    section: section || "",
  });
  return response.data;
};

/** Send a specific bulletin to a single user by ID */
export const sendBulletinToUser = async (
  country: string,
  filename: string,
  userId: number,
  type: string = "ocean"
) => {
  const response = await api.post("/emails/dispatch-bulletin/user", {
    country,
    filename,
    type,
    userId,
  });
  return response.data;
};
